<ng-container *ngIf="iconUrl; else custom">
  <img class="centered-rounded-icon enabled-app-icon" [src]="iconUrl" />
</ng-container>
<ng-template #custom>
  <span
    class="centered-rounded-icon enabled-app-icon-custom"
    [ngStyle]="{ 'background-color': iconColor }"
  >
    {{ appId[0] }}
  </span>
</ng-template>
